export const FORM_TYPE_ADD = "ADD"
export const FORM_TYPE_EDIT = "EDIT"
